import _ from "underts";
const sliceDurees = (availableTime, step) => {
    "use strict";
    return _.range(step, availableTime + step, step);
};
export default sliceDurees;
//# sourceMappingURL=sliceDurees.js.map